export const scheduleMeetingUrl = 'https://calendly.com/klaudia-cembor/30min';
